import { render, staticRenderFns } from "./SMSActivator.vue?vue&type=template&id=e8bd29f6"
import script from "./SMSActivator.vue?vue&type=script&lang=ts"
export * from "./SMSActivator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports